export const PORTAL_URL = "https://cityofmelbourne.maps.arcgis.com"
export const ESRI_CLIENT_ID = "0KBzlPo2662D42j5"
export const ESRI_CREDENTIALS_KEY = "esri-js-credentials"
export const ONE_WEEK_IN_SECONDS = 10080
